export default __webpack_public_path__ + "static/media/chamber-3-5-generic-score-cover.54bd357a.png";